import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.1_react@18.3.1__@emotion+_469e522cd6abb862c8a0738648d8aa07/node_modules/@mui/material/Toolbar/Toolbar.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.31_@babel+core@7.28.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.77.8/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.31_@babel+core@7.28.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.77.8/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(apollo)/productDetail/[id]/components/ProductDetailInit.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(apollo)/productDetail/[id]/productDetails.module.scss");
;
import(/* webpackMode: "eager" */ "/app/public/static/less/quill.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/CountDown/CountDownCmsClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EvalAddScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer/cmsAndNoCmsComponents/components/AdvantageItemClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/cmsAndNoCmsComponents/styles/advantagecms.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/cmsAndNoCmsComponents/styles/footerShare.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/footerBottom.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GetCodeForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GetPriceClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/gtagFunctionComponent/AddGaTopAdClickClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/Announcement/Client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Header/Announcement/styles/notice.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/BottomNotice/BottomNoticeClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Header/Bubble/bubble.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Header/BottomNotice/bottomNotice.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/Bubble/BubbleClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/AppBarClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/FavoriteDrawerClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/HeaderContainerClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/HeaderMenuRightTheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/LeftMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/SearchIconClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/ShoppingCart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/HeaderMenuBar/UserIconClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/SwiperCms/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/InnerAddsComponent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MyFitTag/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SsrPerformance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ButtonLine/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ColorComfirmBtn/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/CountDownPrice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/Delivey/DeleveyChildren.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/H5Hot/H5HotClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/H5Purchase/ProductAdvantage/ProductAdvantageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/H5Similar/ProductRecommended/ProductRecommendedClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/Price/PriceClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/Price/SalePerClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductAccordion/ProductAccordionClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductAccordion/ProductAnswer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductAccordion/ProductDetailsSpecifications/ProductDetailsSpecificationsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductAccordion/ProductDetailsSpecifications/ShowMoreButtonClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductAccordion/ProductShowMore/ProductShowMoreClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductAccordion/VideoItem/VideoItemClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductDetailsColorSelect/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductImgSwiper/CarouselSwiperClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductImgSwiper/productImgSwiper.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductImgSwiper/ProductImgSwiperClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductImgSwiper/ShowAIClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductImgSwiper/ShowChangeVideoImgButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductImgSwiper/ShowSliderGuideClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductPackage/ProductPackageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductPackage/ProductPackageItem/PackageDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductPackage/ProductPackageItem/RxClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/ProductReivew/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/SelectContainer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/SizeChart/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/productDetails/SizeChart/SizeSwiper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterConditionProvider"] */ "/app/src/provider/FilterCondition/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["PackageInfoProvider"] */ "/app/src/provider/PackageInfo/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayoutProvider"] */ "/app/src/provider/PageLayout/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["PrescriptionProvider"] */ "/app/src/provider/Prescription/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailsProvider"] */ "/app/src/provider/ProductDetails/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ProductPackageProvider"] */ "/app/src/provider/ProductPackage/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewAndFqProvider"] */ "/app/src/provider/ReviewAndFq/Provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoProvider"] */ "/app/src/provider/UserInfo/context.ts");
;
import(/* webpackMode: "eager" */ "/app/src/styles/variables.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/Price/price.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/styles/title.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/H5Purchase/ProductAdvantage/productAdvantage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/Delivey/delivey.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductPackage/ProductPackageItem/productPackageItem.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductPackage/productPackage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductAccordion/productDetails.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductAccordion/productShowMore.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductAccordion/VideoItem/videoItem.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductAccordion/styles/videoList.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/productDetails/ProductAccordion/productAccordion.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/ui-component/basic/FmLink/Client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/ui-component/basic/FmThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/ui-component/styles/fmTag.module.scss");
;
import(/* webpackMode: "eager" */ "/app/ui-component/styles/link.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Header/HeaderMenuBar/styles/appBar.module.scss");
;
import(/* webpackMode: "eager" */ "/app/ui-component/basic/FmAccordion/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/ui-component/basic/FmIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/ui-component/basic/FmImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/ui-component/basic/FmRating.tsx");
